import React from 'react';
import { useHistory } from 'react-router-dom'; 
import { Box, Button, Typography } from '@mui/material';

function Page4SubPageB() {
    const history = useHistory(); 
    
    return(
        <Box p={4}>
            <Box display="flex" justifyContent="center" gap={2} mt={2}>
                <Button variant="contained" onClick={() => history.push('/page4/b1')}>
                    Popular
                </Button>
                <Button variant="contained" onClick={() => history.push('/page4/b2')}>
                    Following
                </Button>
                <Button variant="contained" onClick={() => history.push('/page4/b3')}>
                    Browse
                </Button>
            </Box>
        </Box>
    );
}

export default Page4SubPageB;